import { render } from "./HzbaModalItem.vue?vue&type=template&id=615f8b83"
import script from "./HzbaModalItem.vue?vue&type=script&lang=js"
export * from "./HzbaModalItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__